import React from "react";

/**
 * Props for the GoogleLogo component.
 */
interface GoogleLogoProps {
  /**
   * Width of the logo in pixels (default: 18)
   */
  width?: number;
  /**
   * Height of the logo in pixels (default: 18)
   */
  height?: number;
  /**
   * Additional CSS styles to apply to the SVG element
   */
  style?: React.CSSProperties;
  /**
   * Additional CSS class name
   */
  className?: string;
}

/**
 * Reusable Google logo SVG component.
 * Displays the official Google logo with the four-color design.
 *
 * @param {GoogleLogoProps} props - Component props
 * @returns {JSX.Element} The Google logo SVG element
 */
export const GoogleLogo = ({
  width = 18,
  height = 18,
  style,
  className,
}: GoogleLogoProps): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      style={style}
      className={className}
    >
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.8 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.467-.806 5.962-2.184l-2.908-2.258c-.806.54-1.837.86-3.054.86-2.349 0-4.338-1.587-5.049-3.72H.957v2.332C2.438 15.983 5.482 18 9 18z"
      />
      <path
        fill="#FBBC05"
        d="M3.951 10.698c-.18-.54-.282-1.117-.282-1.698s.102-1.158.282-1.698V4.97H.957C.347 6.175 0 7.55 0 9s.348 2.825.957 4.03l3.006-2.332z"
      />
      <path
        fill="#EA4335"
        d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.97L3.963 7.3C4.662 5.163 6.651 3.58 9 3.58z"
      />
    </svg>
  );
};
